import styled from "styled-components";

const Container = styled.section`
  background-color: #ffffff;
  box-shadow: 0 2px 4px rgba(0,0,0,.15);
  padding: 1rem;
`;

export default Container;